import { getSettings } from "../../api/setting";
import { getPersistenceData, removePersistenceData, setPersistenceData } from "../../utils/persistenceStorage";
import { log2 } from "../../utils/log2";
import * as _ from "lodash";

export const defaultPreferredThemeColor = "servquick";
export const defaultPreferredAnimation = "No Animation";
export const defaultContentOfBubbleMessage = "";
export const defaultInputPixels = {
    xAxis: 0,
    yAxis: 0,
};
export const allThemeColors = ["orange", "red", "green", "pink", "purple", "blue", "mango", "servquick"];
export const allAnimations = [
    "No Animation",
    "bounce",
    "flash",
    "pulse",
    "rubberBand",
    "shake",
    "bounceIn",
    "flip",
    "swing",
    "tada",
    "wobble",
    "jello",
];
const log = log2("setting.vuex");
const defaultSetting = {
    language: {},
    chatCustomizationSettings: {
        preferredThemeColor: getPersistenceData("lastPreferredThemeColor") || defaultPreferredThemeColor,
        themeColor1: "#10408f",
        themeColor2: "#236e40",
        preferredAnimation: getPersistenceData("lastPreferredAnimation") || defaultPreferredAnimation,
    },
    loginFormRequired: false,
    isEnabledTriggers: false,
};
const readSettingFromLocalStorage = () => {
    let settings = defaultSetting;
    try {
        settings = getPersistenceData("settings") ? JSON.parse(getPersistenceData("settings")) : defaultSetting;
    } catch (e) {
        console.error("setting json read error", e);
    }
    return settings;
};
const setting = {
    namespaced: true,
    state: {
        allThemeColors,
        allAnimations,
        settings: readSettingFromLocalStorage(),
        offlineMode: false,
        fetched: false,
        inputPixels: defaultInputPixels,
        contentOfBubbleMessage: defaultContentOfBubbleMessage,
    },
    getters: {
        getSetting(state) {
            return setting.state.settings;
        },
    },
    mutations: {
        SET_SETTINGS: (state, payload) => {
            log.debug("SET_SETTINGS", payload);
            const preferredThemeColor = payload.chatCustomizationSettings.preferredThemeColor
                ? payload.chatCustomizationSettings.preferredThemeColor
                : defaultPreferredThemeColor;
            const preferredAnimation = payload.chatCustomizationSettings.preferredAnimation
                ? payload.chatCustomizationSettings.preferredAnimation
                : defaultPreferredAnimation;
            setPersistenceData("lastPreferredThemeColor", preferredThemeColor, true);
            setPersistenceData("lastPreferredAnimation", preferredAnimation, true);
            const oldSettings = _.cloneDeep(state.settings);
            const newSetting = {
                ...payload,
                chatCustomizationSettings: {
                    ...(payload.chatCustomizationSettings || {}),
                    preferredThemeColor: payload.chatCustomizationSettings.preferredThemeColor
                        ? payload.chatCustomizationSettings.preferredThemeColor
                        : defaultPreferredThemeColor,
                    preferredAnimation: payload.chatCustomizationSettings.preferredAnimation
                        ? payload.chatCustomizationSettings.preferredAnimation
                        : defaultPreferredAnimation,
                },
            };
            setPersistenceData("settings", JSON.stringify(newSetting), true);
            state.settings = newSetting;
            state.fetched = true;
            if (oldSettings.customLoginVersion !== newSetting.customLoginVersion) {
                removePersistenceData("lastCustomLogins");
                removePersistenceData("lastLogins");
            }
        },
        OFFLINE_MODE_UPDATED: (state, payload) => {
            // log("OFFLINE_MODE_UPDATED", payload);
            state.offlineMode = payload;
        },
        SET_VERSION: (state, payload) => {
            state.settings.customLoginVersion = payload;
        },
    },
    actions: {
        getSettings({ commit }) {
            return getSettings().then((response) => {
                let settings = {
                    language: {},
                };
                if (response.data.length > 0) {
                    settings = response.data[0];
                }
                if (settings.language == null) {
                    settings.language = {};
                }
                commit("SET_SETTINGS", settings);
            });
        },
        setSettings({ commit }, payload) {
            commit("SET_SETTINGS", payload.settings);
        },
        setVersion({ commit }, payload) {
            commit("SET_VERSION", payload);
        },
        offlineModeUpdated({ commit }, payload) {
            commit("OFFLINE_MODE_UPDATED", payload.offlineMode);
        },
    },
};

export default setting;



// WEBPACK FOOTER //
// ./src/store/modules/setting.js